import {
  getDefaultThumbnail,
  isCompleted,
  isOngoing,
  isUpcoming
} from '@models/Course';
import processAuthorInfo from './user';

export const getCourseAuthors = (course) => {
  if (course?.authors?.length)
    return course?.authors?.map((author) => processAuthorInfo(author, false));
  if (course?.author) return [processAuthorInfo(course.author, false)];
  return [];
};

export const processCourse = (course) => ({
  ...course,
  authors: getCourseAuthors(course),
  liveAt: course.liveAt || course.startsAt,
  liveAtString: course.liveAt || course.startsAt,
  thumbnail:
    course.coverPhotoV1 ||
    course.coverPhoto ||
    course.thumbnail ||
    getDefaultThumbnail(course),
  coverPhoto:
    course.coverPhotoV1 ||
    course.coverPhoto ||
    course.thumbnail ||
    getDefaultThumbnail(course),
  newThumbnail: course.coverPhotoV1,
  language: course.languageDisplay || course.multipleLanguageDisplay?.[0],
  averageRating: course.avgRating,
  conceptTopology:
    course.conceptTopology?.name ||
    course.conceptTopology?.title ||
    course.topologies?.[0] ||
    '',
  isUpcoming: isUpcoming(course.startsAt),
  isOngoing: isOngoing(course.startsAt, course.endsAt),
  isCompleted: course.isCompleted || isCompleted(course.endsAt),
  nextTrack:
    course.nextTrack ||
    course.nextSession ||
    course.nextClass ||
    course.nextItem,
  previousTrack:
    course.previousTrack ||
    course.previousSession ||
    course.previousClass ||
    course.previousItem,
  courseType: course.programmeType,
  forPlus: course.forPlus || course.forSubscription
});
